import { useMemo } from 'react'

export function licenseCodeFrom(
  ownSearch: string,
  parentHash: string
): string | null {
  const own = new URLSearchParams(ownSearch).get('lCode')
  if (own) return own
  const query = parentHash.split('?')[1]
  return (query && new URLSearchParams(`?${query}`).get('lCode')) || null
}

export default function useLicenseCode(): string | null {
  return useMemo(() => {
    let parentHash = ''
    try {
      parentHash = window.parent?.location?.hash ?? ''
    } catch {
      parentHash = ''
    }
    return licenseCodeFrom(window.location.search, parentHash)
  }, [])
}
